import { render, staticRenderFns } from "./GoldStoneClassifyManageModal.vue?vue&type=template&id=7c480945&"
import script from "./GoldStoneClassifyManageModal.vue?vue&type=script&lang=js&"
export * from "./GoldStoneClassifyManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports